import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import slick from 'slick-carousel';

$(function() {
	$(".news-slider").each(function(){
		$(this).slick({	
			infinite: false,
			arrows: true,
			dots: true,
			draggable: true,
			autoplay: false,
			speed: 800,
			slidesToShow: 3,
			variableWidth: false,
			slidesToScroll: 3,
			centerMode: false,
			centerPadding: '80px',
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		});
	});
});

$(window).on('resize orientationchange', function() {
	$(".news-slider").each(function(){
		$(this).slick('init');
	});
});